import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import { iconButtonStyles } from '../../common/elements/Button';
import { layout, radius, shadow, space } from '../../../theme/tokens';
import * as common from '../../common/elements/Form';
import * as StaffCommon from '../../common/elements/Staff';

export const Form = styled(FormikForm)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex-start, not center, so overflowing content stays scrollable */
  justify-content: flex-start;
  width: calc(100% - 2 * ${layout.gutter});
  /* keep tall forms inside the viewport on small screens */
  max-height: calc(100vh - 2 * ${layout.gutter});
  overflow-y: auto;
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.lg};
  ${common.ModalScreenWidthMQs}
`;

export const SubmitChangesButton = styled(StaffCommon.StaffNavButton)``;

export const TargetFieldGroup = styled(common.FieldGroup)`
  width: 100%;
  padding-left: ${space[4]};
  padding-right: ${space[4]};
`;

export const TargetGroup = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas: 'target-text delete';
  align-items: center;
  gap: ${space[2]};
`;

export const DeleteButton = styled.button.attrs({ $tone: 'danger' })`
  ${iconButtonStyles}
  grid-area: delete;
  justify-self: center;
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
